import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type FeatureReleaseStage = 'new' | 'alpha' | 'beta' | null;
export type FeatureStageBadgePresentation = 'default' | 'sidebar';

const stageMetadata = {
  new: {
    label: 'New',
    description: 'New — Recently introduced.',
    variant: 'success' as const,
  },
  alpha: {
    label: 'Alpha',
    description: 'Alpha — Early access. This feature may change significantly.',
    variant: 'warning' as const,
  },
  beta: {
    label: 'Beta',
    description: 'Beta — Available for feedback. This feature may change.',
    variant: 'cyber' as const,
  },
} as const;

export function FeatureStageBadge({
  releaseStage,
  presentation = 'default',
  className,
}: {
  releaseStage?: FeatureReleaseStage;
  /** A dark-sidebar treatment remains owned by this canonical component. */
  presentation?: FeatureStageBadgePresentation;
  className?: string;
}) {
  if (!releaseStage) return null;

  const metadata = stageMetadata[releaseStage];
  return (
    <Badge
      variant={metadata.variant}
      className={cn(
        'shrink-0 whitespace-nowrap',
        presentation === 'sidebar' && 'relative z-10 border-white/40 bg-white/25 text-white shadow-sm',
        className,
      )}
      aria-label={metadata.description}
      title={metadata.description}
    >
      {metadata.label}
    </Badge>
  );
}
